"use strict";
const React = require('react');
const TaskListItem_1 = require('../components/TaskListItem');
const Flex_1 = require('./Flex');
const TaskList = (props) => {
    if (props.tasks.length === 0) {
        return React.createElement(EmptyTaskList, null);
    }
    else {
        return (React.createElement("div", null, props.tasks.map((task, i) => React.createElement(TaskListItem_1.default, {key: i, task: task}))));
    }
};
const EmptyTaskList = () => React.createElement(Flex_1.Column, {style: style.emptyTaskList}, "Add a task to get started. Tap + below.");
const style = {
    emptyTaskList: {
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = TaskList;



/** WEBPACK FOOTER **
 ** ./src/components/TaskList.tsx
 **/